import React from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageVariant } from './languageVariants.types';

interface LanguageVariantSelectorProps {
  currentVariant: LanguageVariant;
  onVariantChange: (variant: LanguageVariant) => void;
}

/**
 * LanguageVariantSelector
 * 
 * Reusable toggle for 3 language variants.
 * Integrated with i18next for multi-language support.
 */
const LanguageVariantSelector: React.FC<LanguageVariantSelectorProps> = ({
  currentVariant,
  onVariantChange,
}) => {
  const { t } = useTranslation();
  const variants: LanguageVariant[] = ['practical', 'neutral', 'reflective'];

  return (
    <div className="flex items-center space-x-2">
      <span className="text-xs text-gray-500">
        {t('languageVariant.label')}
      </span>
      <div className="inline-flex rounded-lg border border-gray-200 bg-gray-50 p-0.5">
        {variants.map((variant) => (
          <button
            key={variant}
            onClick={() => onVariantChange(variant)}
            className={`
              px-3 py-1 text-xs rounded-md transition-all
              ${
                currentVariant === variant
                  ? 'bg-white text-gray-900 shadow-sm'
                  : 'text-gray-600 hover:text-gray-900'
              }
            `}
            title={t(`languageVariant.description.${variant}`)}
          >
            {t(`languageVariant.${variant}`)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageVariantSelector;
